export default "__VITE_ASSET__CeHpG7wz__"